import type { FetchListParams } from 'Services/ProductManagement/types'
import { useSearchParams } from 'react-router-dom'

interface UseProductListTabsProps {
  setSearchQueryParams: React.Dispatch<React.SetStateAction<FetchListParams>>
  tabParamKey?: string
}

interface UseProductListTabsReturn {
  tabFromParams: string
  handleTabChange: (event: React.SyntheticEvent | null, newValue: string) => void
}

export function useProductListTabs({
  setSearchQueryParams,
  tabParamKey = 'tab'
}: UseProductListTabsProps): UseProductListTabsReturn {
  const [searchParams, setSearchParams] = useSearchParams()
  const tabFromParams = searchParams.get(tabParamKey) ?? ''

  const handleTabChange = (_event: React.SyntheticEvent | null, newValue: string) => {
    setSearchQueryParams(prevState => {
      const newParams = { ...prevState, start_index: undefined }

      if (newValue) {
        newParams.filter = `productGroup Eq "${newValue}"`
      } else {
        // Remove filter if newValue is ''
        delete newParams.filter
        searchParams.delete('filter')
      }

      return newParams
    })
    searchParams.set(tabParamKey, newValue)
    setSearchParams(searchParams)
  }

  return {
    tabFromParams,
    handleTabChange
  }
}

export default useProductListTabs
